import {createFileRoute} from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/home/service')({
  staticData: {crumbKey: 'navigation.service'},
});
